import { render, staticRenderFns } from "./NumberDisplay.vue?vue&type=template&id=7505b03a&scoped=true&"
import script from "./NumberDisplay.vue?vue&type=script&lang=js&"
export * from "./NumberDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7505b03a",
  null
  
)

export default component.exports